// MFA phone enrollment targets Spanish numbers - default to the +34 prefix
// when the user doesn't type one, and fix the common "0034" trunk-code mistake.
export function normalizeSpanishPhone(phone: string): string {
  const trimmed = phone.trim();
  if (trimmed.startsWith("0034")) return "+34" + trimmed.slice(4);
  if (trimmed.startsWith("+")) return trimmed;
  return "+34" + trimmed;
}
